import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { Link, useNavigate } from 'react-router-dom'

import AppStore from '../../stores/AppStore'
import Footer from '../partials/Footer'
import NavigationBar from '../partials/NavigationBar'
import SendReportIcon from '../partials/Graphics/SendReportIcon'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/devicePage.module.css'

function CustomerSettingsPage (props) {
  const navigate = useNavigate()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo('/home')
  }, [goTo])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    auth: {
      logout,
    },
    intl: {
      formatMessage,
    },
    route: {
      path: page,
    },
    level,
  } = props

  const ADMIN = formatMessage({
    id: 'customer.settings',
    defaultMessage: 'Settings',
    description: 'settings label',
  })

  const DEVICE_GROUPS = formatMessage({
    id: 'customer.settings.deviceGroups',
    defaultMessage: 'Device Groups',
    description: 'Device Groups label',
  })

  const DEVICES_INACTIVE = formatMessage({
    id: 'customer.settings.devicesInactive',
    defaultMessage: 'Inactive Devices',
    description: 'Inactive Devices label',
  })

  const REPORTS = formatMessage({
    id: 'customer.settings.reports',
    defaultMessage: 'Run Reports',
    description: 'reports label',
  })

  const USERS = formatMessage({
    id: 'customer.settings.users',
    defaultMessage: 'Users',
    description: 'Users label',
  })

  const {
    pages: {
      CustomerSettingsPage: title = ADMIN,
    },
  } = props

  const {
    id: customerID,
  } = AppStore.getCustomer()

  const navButton = (subPage, label, icon) => (
    <div key={label} style={{ display: 'inline-block' }}>
      <Link
        to={subPage.match(/^[a-z]{1,25}/i) ? `/${customerID}/settings/${subPage}` : subPage}
        className={styles.settingButtonCustomer}
      >
        <div className={styles.settingIcon}>

          {icon instanceof Object && (icon)}
          {!(icon instanceof Object) && (
            <i className={`fa ${icon}`} />
          )}
          &nbsp;
        </div>
        <div className={styles.settingName}>
          <h3>
            {label}
          </h3>
        </div>
        <div className={styles.settingValue}>
          <h3 />
        </div>
      </Link>
    </div>
  )

  const navButtons = [navButton('users', USERS, 'fa-users')]

  if (level >= 20) {
    navButtons.push(navButton('deviceGroups', DEVICE_GROUPS, 'fa-th'))
    navButtons.push(navButton(`/${customerID}/devices?isActive=false`, DEVICES_INACTIVE, 'fa-trash-o'))
  }

  if (level >= 10) {
    navButtons.push(navButton('reports', REPORTS, <SendReportIcon />))
  }

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={page}
        name={ADMIN}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          {navButtons}
        </div>
      </div>
      <Footer />
    </div>
  )
}

CustomerSettingsPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
  level: PropTypes.number,
}

export default withAppStore(injectIntl(CustomerSettingsPage))
